import { actionType } from "../constants/labels";
import { mockDashboard } from "../constants/mockData";

export const mockActions = mockDashboard.actionItems.map((item, index) => ({
  exception_id: `mock-${index}`,
  order_id: item.order_id || item.order_line_id,
  order_line_id: item.order_line_id,
  order_no: item.order_no,
  customer_name: item.customer_name,
  site_name: "납품처 미등록",
  item_name_snapshot: item.item_name_snapshot,
  requested_due_date: item.requested_due_date,
  schedule_status: item.schedule_status || "CHECK_REQUIRED",
  risk_level: item.risk_level,
  production_plan_status: "NOT_REVIEWED",
  exception_type: item.action_type,
  severity: item.risk_level === "OVERDUE" ? "CRITICAL" : item.risk_level === "HIGH" ? "HIGH" : "ATTENTION",
  exception_title: actionType[item.action_type] || "확인 필요",
  exception_message: "주문 일정 확인 또는 생산계획 검토가 필요합니다.",
}));

export const getActionItems = (dataItems, search) => {
  if (dataItems.length) return dataItems;
  return search ? [] : mockActions;
};

export const isMockAction = (item) => String(item?.exception_id || "").startsWith("mock");
